import React from "react";

import bgImg01 from "images/17.jpg";
import bgImg02 from "images/20.jpg";
import bgImg03 from "images/18.png";
import shape from "images/shape_red.png";

const About = () => {
	return (
		<div
			id="about"
			className="rts-cleaning-home-about rts-section-gap"
			style={{ backgroundColor: "#f7f7f7" }}>
			<div className="container">
				<div className="row">
					<div className="col-lg-6 pr--70 pr_sm--0">
						<div className="cleaning-home-about-left-img">
							<div className="thumbnail">
								<img
									src={bgImg01}
									alt="Operaio al lavoro su una parete in cartongesso durante una fase di installazione"
								/>
								<div className="shape">
									<img src={shape} alt="TecnoCGE" />
									<div className="inner-content">
										<h6>30+</h6>
										<p>anni di esperienza</p>
									</div>
								</div>
							</div>
							<div className="small-image images">
								<img src={bgImg02} alt="Dettaglio di lavorazione su cartongesso a muro" />
							</div>
						</div>
					</div>
					<div className="col-lg-6 pr--50 pt_sm--30">
						<div className="about-cleaning-right-content mt_md--30 mt_sm--30">
							<div className="title-area-left">
								<p className="pre">
									<span>Storia</span> di Successo
								</p>
								<h2 className="title">Maestria nel cartongesso</h2>
							</div>
							<div className="inner-content-about-cleaning">
								<p className="disc">
									Fondata più di 30 anni fa con l’ambizione di trasformare ogni spazio in un’opera
									di precisione e design, <b>TecnoCGE</b> è cresciuta grazie alla passione e
									all’esperienza. Oggi siamo un punto di riferimento per chi cerca soluzioni su
									misura, combinando innovazione e artigianalità. Ogni progetto è per noi una
									nuova sfida, affrontata con la cura e l’attenzione che solo trenta anni di
									dedizione possono garantire.
								</p>
								<div className="experience">
									<img
										src={bgImg03}
										alt="Operaio prende misure per installazione pannello di cartongesso"
									/>
									<p className="exp">
										30+ anni <br />
										di know-how sul campo
									</p>
								</div>
								<div className="short-cta">
									<div className="call">
										<i className="fa-light fa-phone" />
										<div className="info">
											<span>Chiamaci!</span>
											<a href="tel:+393356197378" className="number">
												335 61 97 378
											</a>
										</div>
									</div>
									<a href="#" className="rts-btn btn-primary">
										Clicca per chiamare
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default About;
